import colors from '../foundation/colors';

const Switch = {
  baseStyle: {
    track: {
      bg: 'linear-gradient(90deg, rgb(233, 241, 247) 0%, rgb(174, 197, 216) 50%)',
      _checked: {
        background: colors.gradient.brandSecondary
      }
    },
    label: {
      display: 'flex',
      alignItems: 'center'
    }
  }
};

export default Switch;
